/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<User>, schemaOptions: { partial: true })
 */
export interface UserPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    firstName?: string;
    hasWhatsApp?: boolean;
    lastName?: string;
    middleName?: string;
    username?: string;
    email?: string;
    phone?: string;
    defaultTenant?: number;
    lastLogin?: string;
    dateBirth?: string;
    dateAdmission?: string;
    recognitionDate?: string;
    enrollment?: string | null;
    isDefaultEnrollment?: boolean;
    isSystemAccount?: boolean;
    rfc?: string;
    curp?: string;
    imss?: string;
    address?: string;
    residence?: string;
    departmentName?: string;
    photoProfileUrl?: string;
    uuid?: string;
    companyId?: string;
    homeCompanyId?: string;
    jobPositionId?: string;
    departmentId?: string;
    areaId?: string;
    jobCategoryId?: string;
    processNumber?: number;
    businessUnitId?: string;
    inactiveReasonId?: string;
    cityId?: string;
    personalRequisitionId?: string | null;
    vacancyId?: string | null;
    inactivatedOn?: string;
    inactivatedBy?: number;
    otherInactiveReason?: string;
    inactiveComments?: string;
    payrollDate?: string;
    payrollInactivatedOn?: string;
}

